import { Add, Remove } from "@mui/icons-material"
import { AccordionDetails, AccordionSummary, Accordion as MuiAccordion } from "@mui/material"
import T from "prop-types"
import { cx } from "ramda-extension/es"
import React, { useEffect } from "react"

import { useDynamicDetailsOverrides, useDynamicOverrides, useOverrides } from "./css.js"

export const Accordion = ({
  expandedSummaryText,
  fontColor,
  children,
  className,
  color = "primary",
  content,
  contentHeight,
  preExpanded = false,
  accordionID = false,
  activeAccordionID = false,
  onChange = (event) => event,
  onScroll = (event) => event,
  summaryText,
  verticalOverflow,
  withPaddings = false,
  id
}) => {
  const [expanded, setExpanded] = React.useState(preExpanded)

  useEffect(() => {
    setExpanded(accordionID === activeAccordionID)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeAccordionID])

  const { accordionRoot, summaryRoot } = useOverrides({ withPaddings })
  const { summaryContent } = useDynamicOverrides({ color, fontColor, withPaddings })

  const toggle = () => {
    setExpanded(!expanded)
    if (accordionID && !expanded) onChange(accordionID)
  }

  return (
    <MuiAccordion
      expanded={expanded}
      classes={{ root: accordionRoot }}
      onChange={toggle}
      square={true}>
      <AccordionSummary
        classes={{
          content: summaryContent,
          root: cx(className, summaryRoot),
        }}
        id={id}>
        {expandedSummaryText ? (expanded ? expandedSummaryText : summaryText) : summaryText}
        {expanded && <Remove viewBox="0 0 28 28" style={{ color: "#333" }} />}
        {!expanded && <Add viewBox="0 0 28 28" style={{ color: "#333" }} />}
      </AccordionSummary>
      <AccordionDetails
        onScroll={onScroll}
        classes={useDynamicDetailsOverrides({ contentHeight, verticalOverflow, withPaddings })}>
        {content || children}
      </AccordionDetails>
    </MuiAccordion>
  )
}

Accordion.propTypes = {
  /** ID for accordion if you wan't make controlled accordion */
  accordionID: T.oneOfType([T.string, T.bool]),
  /** ID of active (expanded) accordion if you wan't make controlled accordion */
  activeAccordionID: T.oneOfType([T.string, T.bool]),
  content: T.oneOfType([T.element, T.node]),
  contentHeight: T.string,
  expanded: T.bool,
  expandedSummaryText: T.string,
  /**
   * function for set active (expanded) accordion, that comes from parent
   * and have to return string (accordion ID) or undefined
   * */
  onChange: T.func,
  /** Default state for expanded value */
  preExpanded: T.bool,
  summaryText: T.string,
}
